'use strict'; //

exports.__esModule = true;
exports.default = void 0;

require("../css/animate.min.css");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _component = _interopRequireDefault(require("../core/component"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

//
var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
/**
 * 动画组件
 * 动画组件不适用 setState方法更新组件 防止子组件的重复刷新
 */

var Animate = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Animate, _Component);

  function Animate(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {};

    _this.handlerCheckDisplay = function () {
      if (_this.props.display) {
        (0, _jquery.default)(_this.animated).css({
          display: _this.state.css || 'block'
        });
      } else {
        _this.state.css = (0, _jquery.default)(_this.animated).css('display');
        (0, _jquery.default)(_this.animated).css({
          display: 'none'
        });
      }
    };

    _this.handlerAnimationEnd = function (e) {
      _this.handlerCheckDisplay();

      _this.props.onAnimationEnd && _this.props.onAnimationEnd();
      e.stopPropagation();
      return false;
    };

    _this.handlerAnimationStart = function (e) {};

    _this.handlerAnimationIteration = function (e) {};

    return _this;
  }
  /**
   * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
   */


  var _proto = Animate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    (0, _jquery.default)(this.animated).css(this.props.style || {}).attr('class', (0, _classnames.default)("animated", this.props.name, this.props.className));
    this.handlerCheckDisplay();
  }
  /**
   * 输入参数 nextProps 是即将被设置的属性，
   * 旧的属性还是可以通过 this.state 来获取。
   * 在这个回调函数里面，你可以根据属性的变化，
   * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
   * 并不会触发额外的 render() 调用
   */
  ;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _jquery.default)(this.animated).attr('class', (0, _classnames.default)("animated ", nextProps.name, nextProps.className)).css(nextProps.style || {});

    if (nextProps.display) {
      (0, _jquery.default)(this.animated).css({
        display: 'block'
      });
    }
  }
  /**
   *
   * @returns {XML}
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var Elem = this.props.elem || 'div';
    return /*#__PURE__*/_react.default.createElement(Elem, {
      ref: function ref(animated) {
        return _this2.animated = animated;
      },
      onClick: this.props.onClick,
      onWheel: this.props.onWheel,
      onAnimationEnd: this.handlerAnimationEnd,
      onAnimationStart: this.handlerAnimationStart,
      onAnimationIteration: this.handlerAnimationIteration
    }, this.props.children);
  }
  /**
   *
   * @private
   */
  ;

  return Animate;
}(_component.default);

Animate.displayName = "Animate";
Animate.defaultProps = {
  display: true
};
var _default = Animate;
exports.default = _default;
module.exports = exports.default;